<template>
    <section>
        <div class="page-wrap">
            <div class="container checkout">
                <div class="box-content">
                    <div class="row">
                        <div class="col-md-6 border-success-right">
                            <h2>Checkout</h2>
                            <div>
                                <div class="th hidden-xs">
                                    <div class="row">
                                        <div class="col-sm-4">PRODUCT</div>
                                        <div class="col-xs-8">
                                            <div class="row">
                                                <div class="col-xs-7">DESCRIPTION</div>
                                                <div class="col-xs-2 text-center">QTY</div>
                                                <div class="col-xs-3 col-md-3 text-right">SUBTOTAL</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tb" v-for="(item, itemIndex) in cart">
                                    <div class="row">
                                        <div class="col-sm-4 cart-img">
                                            <div class="prod-container">
                                                <img v-if="item.gc" class="prod-img" src="images/giftcertificate.png"/>
                                                <img v-else class="prod-img" v-bind:src="getCartItemImage(item)"/>
                                                <div class="prod-replica">
                                                    <div class="prod-replica-table">
                                                        <div class="prod-replica-table-td checkout" v-bind:class="products[item.item_id].classes">
                                                            <p v-for="n in products[item.item_id].max_lines">{{ item.lines[n-1] }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-8">
                                            <!-- base product first -->
                                            <div class="row tr">
                                                <div class="col-xs-7" v-html="products[item.item_id].description"></div>
                                                <div class="col-xs-2 text-center">
                                                    <div class="wrap-count">
                                                        <div class="amount">
                                                            <span>1</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xs-3 col-md-3 text-right price">
                                                    <span class="pull-left">$&nbsp;</span>{{ products[item.item_id].price }}
                                                </div>
                                            </div>
                                            <!-- list of dependent products -->
                                            <div class="row tr" v-for="(qty, childId) in item.children">
                                                <div class="col-xs-7"
                                                     v-html="childProducts[item.item_id].children[childId].description"
                                                ></div>
                                                <div class="col-xs-2 text-center">
                                                    <div class="wrap-count">
                                                        <div class="amount">
                                                            <span>{{ qty }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xs-3 col-md-3 text-right price">
                                                    <span class="pull-left">$&nbsp;</span>
                                                    {{ calcLineItemTotal(item.item_id, childId, qty) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right">
                                    <div class="total">Subtotal
                                        <span class="wrap">
                                            <span class="pull-left">$&nbsp;</span>{{ subTotal | currency({symbol: ''}) }}
                                        </span>
                                    </div>
                                    <div class="total" v-if="isConvenienceFeeAllowed">Processing&nbsp;Fee
                                        <span class="wrap">
                                            <span class="pull-left">$&nbsp;</span>{{ convenienceFee | currency({symbol: ''}) }}
                                        </span>
                                    </div>
                                    <div class="total">Sales&nbsp;Tax
                                        <span class="wrap">
                                            <span class="pull-left">$&nbsp;</span>{{ salesTax | currency({symbol: ''}) }}
                                        </span>
                                    </div>
                                    <strong class="subtotal">Order&nbsp;Total:
                                        <span>$&nbsp;</span>{{ orderTotal | currency({symbol: ''}) }}
                                    </strong>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 border-success payment">
                            <h2 class="billing-info">Payment Information</h2>
                            <div class="embed-responsive embed-responsive-4by3">
                                <friendly-iframe :src="iframeUrl" className="quantum-payment-iframe"></friendly-iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <payment-declined-popup></payment-declined-popup>
    </section>
</template>

<script type="text/jsx">
    import Vue from 'vue';
    import { Event } from '../../../../assets/js/components/frontend/event.vue'
    import { mapState, mapGetters } from 'vuex'
    import store from '../store'
    // mixins
    import CampaignConfigurationMixin from '../../../../assets/js/components/frontend/mixin/campaign-configuration.vue'
    import OrderCreationMixin from '@/components/mixin/order-creation.vue'
    // elements
    import FriendlyIframe from '../../../../assets/js/components/frontend/elements/friendly-iframe.vue';
    import PaymentDeclined from '@/components/popup/payment-declined.vue';

    // tests
    // import { payment as testPayment } from '%/store/addressbook'
    // import { payment as testPayment } from '%/store/all2another'

    export default {
        name: 'payment',
        mixins: [
            CampaignConfigurationMixin,
            OrderCreationMixin
        ],
        components: {
            'friendly-iframe': FriendlyIframe,
            'payment-declined-popup': PaymentDeclined
        },
        beforeRouteEnter(to, from, next) {
            if (from.name === 'Checkout' && store.getters.cartItemsCount > 0) {
                next();
            } else {
                next({name: 'Checkout'});
            }
        },
        computed: {
            ...mapState([
                'campaign', 'orderId', 'tokenKey', 'ipAddr', 'quantum'
            ]),
            ...mapGetters([
                'billing', 'products', 'childProducts', 'cart',
                'subTotal', 'promoDiscount', 'salesTax'
            ]),
            ...mapGetters({
            }),
            baseImagePath: function () {
                return 'images/catalog/' + this.campaign.short_url + '/';
            },
            iframeUrl: function () {
                const params = Object.assign({
                    // auth
                    k: this.tokenKey,
                    ip: this.ipAddr,
                    // mandatory
                    Amount: this.orderTotal,
                    ID: this.orderId,
                    post_return_url_approved: this.quantum.approved,
                    post_return_url_declined: this.quantum.declined,
                    // optional
                    FNAME: this.billing.first_name,
                    LNAME: this.billing.last_name,

                    BADDR1: this.billing.address1,
                    BCITY: this.billing.city,
                    BSTATE: this.billing.state_prov,
                    BZIP1: this.billing.postal_code,
                    BCOUNTRY: this.billing.country,

                    phone: this.billing.phone,
                    BCUST_EMAIL: this.billing.email,
                }, this.gateway.params);
                const query = '?' + Object.keys(params).map(function(key) {
                    return key + '=' + encodeURIComponent(params[key])
                }).join('&');
                return this.quantum.payment + query;
            }

        },
        created: function () {
            Event.$on('onPaymentDeclinedPopupSubmit', this.onPaymentDeclinedConfirmed);
        },
        mounted: function () {
            // Listen to message from iframe element
            window.addEventListener('message', this.messageEventListener);
            // Setup periodical requests for keeping tokenKey fresh
            this.timerId = setInterval(() => {
                const payload = {
                    k: this.tokenKey,
                    ip: this.ipAddr,
                };
                this.$http.post(this.quantum.refresh, payload).then(function(response) {
                }, function (error) {
                    console.log('Network error: ', error);
                });
            }, 20 * 1000);
        },
        beforeDestroy: function () {
            window.removeEventListener('message', this.messageEventListener);
            Event.$off('onPaymentDeclinedPopupSubmit', this.onPaymentDeclinedConfirmed);
            clearInterval(this.timerId);
        },
        data: function () {
            return this.getDefaultData();
        },
        methods: {
            getDefaultData: function () {
                return {
                    // payment: testPayment, // DEBUG
                    /**/
                    payment: {
                        amount: ''
                    },
                    /**/
                    errs: {
                        payment_cc: ''
                    },
                    gateway: {
                        params: {
                            skip_shipping_info: 'Y',
                            ilf_API_Style: '2',
                            Require_BCOUNTRY: 'Y',
                            Require_phone: 'N',
                            PayInfoOnly: 'Y',
                            ts: +new Date(), // anti-cache param to re-invoke URL in iframe component when needed
                        }
                    },
                    timerId: null
                }
            },
            calcLineItemTotal: function (prodId, childId, qty) {
                var price = this.childProducts[prodId].children[childId].price;
                return Vue.filter('currency')(price * qty, {symbol: ''});
            },
            getCartItemImage: function (cartItem) {
                var itemId = cartItem.item_id;
                var product = this.products[itemId];
                var logosList = {};
                if (this.isMultiLogoAllowed) {
                    if ("options" in product && product.options) {
                        if ("logo" in product.options && product.options.logo) {
                            logosList = product.options.logo;
                        }
                    }
                }
                var res = '';
                var logoId = 'logo' in cartItem.options ? cartItem.options.logo : '';
                if (logoId in logosList) {
                    res = this.baseImagePath + logosList[logoId].item_image_blank;
                    return res;
                }
                res = this.baseImagePath + product.item_image_blank;
                return res;
            },
            messageEventListener (e) {
                if (e.data.event === 'payment-result') {
                    var data = e.data.data;
                    var success = 'success' in data ? data.success : false;
                    var result = 'result' in data ? data.result : 'DECLINED';
                    if (success && result == "APPROVED") {
                        this.$store.commit('completeTheOrder');
                        this.$router.push({ path: '/confirmation'});
                    } else {
                        var error = 'error' in data ? data.error : '';
                        if (success && 'decline_reason' in data) {
                            error = 'decline_reason' in data ? data.decline_reason : error;
                        }
                        Event.$emit('paymentDeclinedPopupInvokeModal', { declinedMessage: error });
                    }
                }
            },
            onPaymentDeclinedConfirmed: function (payload) {
                // to trigger "friendly-iframe" reload due to "iframeUrl" change
                this.gateway.params = Object.assign({}, this.gateway.params, { ts: +new Date() });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Payment.vue?7b22f3a2